import api, { unwrap } from './client';
import { getPlView, setCogsAlign, setLineForecast, updateLine } from './financials_pl';
import { opsViaSop } from './opsRoute';

/* Charges directes et variables (2026-09-29). Qui lit la finance reçoit le
   compte de résultat ; le rôle Opérations, la vue à liste blanche de
   `/api/sop/costs`, même forme pour ce que la carte lit. */
export const getCostsView = (tenantId, year) => (opsViaSop()
  ? unwrap(api.get(`/sop/costs/${tenantId}`, { params: { year } }))
  : getPlView(tenantId, year));

export const setCostForecast = (tenantId, payload) => (opsViaSop()
  ? unwrap(api.patch(`/sop/costs/${tenantId}/forecast`, payload))
  : setLineForecast(tenantId, payload));

export const updateCostLine = (tenantId, lineId, patch) => (opsViaSop()
  ? unwrap(api.patch(`/sop/costs/${tenantId}/lines/${lineId}`, patch))
  : updateLine(tenantId, lineId, patch));

export const setCostAlign = (tenantId, year, aligned) => (opsViaSop()
  ? unwrap(api.put(`/sop/costs/${tenantId}/cogs-align`, { year, aligned }))
  : setCogsAlign(tenantId, year, aligned));

// Variation de stock « Selon plan » : 'calc' ou 'manual' (2026-09-30).
export const setStockVarMode = (tenantId, year, mode) => unwrap(api.put(
  opsViaSop() ? `/sop/costs/${tenantId}/stock-var-mode` : `/financials/pl/${tenantId}/stock-var-mode`, { year, mode }));
